var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBannerBadgeAb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 31,
    viewBox: "0 0 47 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 31,
    rx: 15.5,
    fill: "#F7E237"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.052 16.534-.52-3.404-2.071 3.404h2.59zm-5.797 3.131c.26-.077.451-.162.574-.253.182-.132.385-.378.608-.738l5.196-8.23h.362l1.34 8.004c.091.538.2.868.328.991.128.119.408.194.84.226V20H16.26v-.335c.4-.032.683-.096.847-.191.17-.1.253-.306.253-.616 0-.104-.025-.355-.075-.752-.009-.082-.054-.421-.136-1.018h-3.015l-.82 1.422c-.055.095-.105.2-.15.314a.968.968 0 0 0-.062.328c0 .192.057.315.17.37.119.054.363.102.732.143V20h-2.748v-.335zm13.16-9.351h1.004l-3.274 9.918H21.14l3.274-9.918zm4.689 4.538c.683-.054 1.15-.109 1.4-.164.256-.059.49-.184.705-.376.269-.241.463-.576.581-1.004a3.07 3.07 0 0 0 .116-.828c0-.41-.086-.742-.26-.998-.173-.26-.515-.39-1.025-.39-.214 0-.364.05-.451.151-.082.1-.15.255-.205.465l-.861 3.144zm-1.101 4.266c0 .192.1.322.3.39.115.036.292.055.534.055.889 0 1.527-.41 1.914-1.231.232-.488.349-.994.349-1.518 0-.642-.221-1.075-.664-1.298-.264-.133-.747-.215-1.449-.246l-.922 3.418a1.457 1.457 0 0 0-.048.19c-.01.07-.014.149-.014.24zm-3.13.527c.309-.041.528-.105.655-.192.21-.141.37-.412.479-.813l1.723-6.283c.05-.186.086-.341.109-.464.023-.123.034-.22.034-.288 0-.25-.07-.407-.212-.471-.141-.069-.41-.114-.806-.137v-.362h3.807c1.048 0 1.86.166 2.434.499.579.328.868.861.868 1.6 0 .715-.356 1.287-1.066 1.715-.383.233-.896.426-1.539.581.588.21 1.005.42 1.251.63.415.35.622.83.622 1.442 0 .77-.316 1.447-.95 2.03-.633.579-1.693.868-3.178.868h-4.232v-.355z",
    fill: "#672C78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBannerBadgeAb);
export default __webpack_public_path__ + "static/media/main_banner_badge_ab.0869b822b88234e91d94a7b81cfff165.svg";
export { ForwardRef as ReactComponent };